<!-- google 一建授权登录 -->
<template>
  <el-container>
    <div id="g_id_onload"
         data-client_id="639588403126-iao8aif7s0j6jheb2b048d2aqkbu5j26.apps.googleusercontent.com"
         data-context="signin"
         data-callback="googleOneTouchCallback"
         data-nonce=""
         data-auto_select="true"
         data-itp_support="true">
    </div>
  </el-container>
</template>

<script>
import { authorizedLogin } from '@/request/login.js'

export default {
  name: 'googleOneTouchModule',
  props: {},
  components: {
    authorizedLogin
  },
  data () {
    return {}
  },
  watch: {},
  created () {
  },
  mounted () {
    let token = localStorage.getItem('token')
    // 判断是否加载google授权登录.
    if (!token) {
      let script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = 'https://accounts.google.com/gsi/client'
      document.body.appendChild(script)
      window.googleOneTouchCallback = this.googleOneTouchCallback
      console.log('google init')
    } else {
      console.log('user is login')
    }
  },
  methods: {
    googleOneTouchCallback (data) {
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      var sessionid = this.common.sessionidGet(this)
      let requestDataJson = {'credential': data.credential, 'time': time, 'sessionid': sessionid, 'operation': 'Google', 'oneTouch': 1}
      var requestData = this.common.encryptionData(requestDataJson, this)
      authorizedLogin(requestData).then(res => {
        if (res.flag === '200' || res.flag === '201') {
          localStorage.setItem('token', res.data.token)
          window.location.reload()
        } else if (res.flag === '102' || res.flag === '103') {
          this.$message({
            type: 'error',
            message: this.$t(res.msg)
          })
        }
      })
    }
  },
  computed: {}
}
</script>



// WEBPACK FOOTER //
// src/components/login/module/googleOneTouch.vue